import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import * as compose from 'lodash.flowright';
import { Mutation } from 'react-apollo';
import Skeleton from '@material-ui/lab/Skeleton';
//styles and icons 
import { Paper, Button, TextField, InputLabel, Typography, FormControl, Select, Chip } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Row, Col, Modal } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import SpecIcon from '../../../images/speciality.svg';


// this component represent the profile speciality part in explore opportunities page 
class Speciality extends Component {
    constructor(props) {
        super(props);
        this.state = {
            choosenSpecialities: []
        }
    }
    getUserData = () => {
        if (localStorage.jwt) {
            //handle fetch specialities and tags dropdown   
            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = 'https://spreago.black-squares.com/graphql';
            const id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });
            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;

                next();
            });
            //get user data
            apolloFetch({
                query:
                    `query($user_id : Int !){
                        user(id: $user_id){
                        id
                        specialities{
                            id
                            name
                        }
                  }
              }
       `, variables: { user_id: id }
            }).then(res => {
                //get user data
                apolloFetch({
                    query:
                        `  query{
                            specialities{
                            id
                            context
                            name
                            name_en
                            name_ar
                            created_at
                            updated_at
                            }
                        }
        `, variables: { user_id: id }
                }).then(result => {
                    this.setState({ ...this.state, userData: res.data.user, specialities: result.data.specialities });
                });
            });
        }
    }
    componentWillMount() {
        this.getUserData()
    }
    closeSpeciality = () => this.setState({ ...this.state, showSpeciality: false });
    handleDelete = (chipToDelete) => () => {
        let deleteSpeciality = this.state.specialities.filter(speciality => speciality.name === chipToDelete);
        let arr = [];
        console.log(deleteSpeciality[0].id)
        arr.push(deleteSpeciality[0].id);
        this.props.delete_specialities({
            variables: {
                RemoveSpecialitie: arr
            }
        }).then((res, loading) => {
            if (res.data.Userupdate.Status.code === 200) {
                let updateddata = res.data.Userupdate.user;
                this.setState({ ...this.state, userData: updateddata })
            }
        })
    };
    render() {
        if (!this.state.userData) {
            return (
                <div className="">
                    <Skeleton animation="wave" width={170} height={40}/>
                    <Skeleton  className="mb-2" variant="rect" animation="wave"  height={160}/>
                </div>
            )
        } else {
            return (
                <div className="speciality mt-4">
                    <Paper className="p-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                        <Row >
                            <Col md={12}>
                                <Row className="m-0 mb-3 align-items-center">
                                    <Col className="text-left p-0">
                                        <h6 className="bold mb-0">
                                            <span className="pr-3"><img src={SpecIcon} alt="icon" /></span
                                        >Specialties</h6>
                                    </Col>
                                    <Col className="text-right p-0">
                                     
                                            <button
                                                onClick={e => this.setState({ ...this.state, showSpeciality: true })}
                                                className="bg-transparent border-0">
                                                <h6>
                                                    Add new
                                                </h6>
                                            </button>
                                    </Col>
                                    <Modal
                                        size="md"
                                        centered
                                        className="row m-0  pr-0"
                                        show={this.state.showSpeciality}
                                        onHide={this.closeSpeciality}>
                                        <Col xs={12} className="p-0">
                                            <Modal.Header className="p-2 pr-3 pl-3 bg-lightgrey" closeButton>
                                                <Modal.Title className="h5 ">Add new speciality</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body className="p-4">
                                                <div className="rounded-circle w-100">
                                                    <InputLabel className="pb-2" htmlFor="speciality">
                                                        Speciality
                                                    </InputLabel>
                                                    <Autocomplete
                                                        multiple
                                                        id="speciality"
                                                        className="pt-1 mb-4 speciality-tags"
                                                        onChange={
                                                            (event, value) => this.setState({ ...this.state, choosenSpecialities: value })
                                                        }
                                                        options={(this.state.specialities) ? this.state.specialities.map(option => option.name) : ''}
                                                        renderTags={(value, getTagProps) =>
                                                            value.map((option, index) => (
                                                                <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                                                            ))
                                                        }
                                                        renderInput={params => (
                                                            <TextField {...params} variant="outlined" />
                                                        )}
                                                    />
                                                </div>
                                                <div>
                                                    {(this.state.userData && this.state.userData.specialities.length > 0) ?
                                                        <div className="speciality-tags">
                                                            <div><p className="mb-1 capitalize">Your Recent Specialities</p></div>
                                                            {this.state.userData.specialities.map(speciality =>
                                                                <Chip
                                                                    label={speciality.name}
                                                                    className=" m-1"
                                                                    // onDelete={this.handleDelete(speciality.name)}
                                                                />
                                                                // <Button size="small" variant="outlined"  className="btn-black">{speciality.name}</Button>
                                                            )}
                                                        </div>
                                                        : ''}
                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer className="custom pr-3 pl-3 border-0">
                                                <Row className="m-0 w-100">
                                                    <Col xs={6} className="text-left p-0">
                                                        <Button
                                                            type="button"
                                                            size="large"
                                                            className="btn-white-outline  pr-4 pl-4" variant="contained"
                                                            onClick={() => this.closeSpeciality()}>
                                                            Cancel
                                                    </Button>
                                                    </Col>
                                                    <Col xs={6} className="text-right p-0">
                                                        <Mutation mutation={SAVE_SPECIALITIES}>
                                                            {(Userupdate, { data, loading }) =>
                                                                <div>
                                                                    <Button
                                                                        type="button"
                                                                        size="large"
                                                                        className="btn-orange-gradiant pr-4 pl-4" variant="contained"
                                                                        onClick={() => {
                                                                            let specialities = this.state.choosenSpecialities;
                                                                            let arr = []
                                                                            specialities.map(spec => {
                                                                                let x = this.state.specialities.filter(speciality => speciality.name === spec);
                                                                                if (x[0] && x[0].id) {
                                                                                    arr.push(x[0].id);
                                                                                }
                                                                            })
                                                                            console.log(arr)
                                                                            Userupdate({
                                                                                variables: {
                                                                                    AddSpecialitie: arr
                                                                                }
                                                                            }).then((res, loading) => {
                                                                                if (res.data.Userupdate.Status.code === 200) {
                                                                                    let updateddata = res.data.Userupdate.user;
                                                                                    this.setState({ ...this.state, userData: updateddata })
                                                                                    this.closeSpeciality();
                                                                                }
                                                                            }).catch((err) => console.log(err));
                                                                        }}>
                                                                        Save
                                                                </Button>
                                                                    {loading &&
                                                                        <div className="loading">
                                                                            <Loader
                                                                                type="TailSpin"
                                                                                color="white"
                                                                                height={50}
                                                                                width={50}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            }
                                                        </Mutation>
                                                    </Col>
                                                </Row>
                                            </Modal.Footer>
                                        </Col>
                                    </Modal>
                                </Row>
                                <Row className="m-0">
                                    <Col className="p-0">
                                        {(this.state.userData) ?
                                            this.state.userData.specialities.map(speciality =>
                                                // <Button style={{ cursor: 'auto' }} className="btn-black m-1" variant="outlined" size="small">{speciality.name}</Button>) : ''}
                                                <div className="speciality-tags d-inline-block">
                                                    <Chip
                                                    label={speciality.name}
                                                    onDelete={this.handleDelete(speciality.name)}
                                                    className=" m-1"
                                                    /></div>) : ''}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Paper>
                </div>
            )
        }
    }
}

const SAVE_SPECIALITIES = gql`
mutation( $AddSpecialitie : [Int!]){
        Userupdate(data : {
          AddSpecialitie : $AddSpecialitie
        }){
        user{
            id
            specialities {
                id 
                name
            }
        }
        Status{
            code
        }
        }
    }
`
const DELETE_SPECIALITIES = gql`
mutation( $RemoveSpecialitie : [Int!]){
        Userupdate(data : {
          RemoveSpecialitie : $RemoveSpecialitie
        }){
        user{
            id
            specialities {
                id 
                name
            }
        }
        Status{
            code
        }
        }
    }
`

export default compose(
    graphql(SAVE_SPECIALITIES, {
        name: 'save_specialities'
    }),
    graphql(DELETE_SPECIALITIES, {
        name: 'delete_specialities'
    })
)(withRouter(Speciality))
